import type { FaireProductEntity } from "../../entity_types/product";

export const p_b9t6tgt94t: FaireProductEntity = {
  token: "p_b9t6tgt94t",
  type: "product",
  name: "DreamWrite - Lush Flora Series Pens",
  brandName: "BV by Bruno Visconti",
  imageUrl:
    "https://cdn.faire.com/fastly/d194f7eb17424735dd44fbac8802ed14de13951b1371a65f53b49e19c534118b.jpeg",
  priceDollars: 3,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/35a852d184d2f10007658fe7938aeef420a25e0a918aabab9bd5122dbb557bf2.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
